export default __webpack_public_path__ + "static/media/magnifying-glass.b4b44b94.svg";